// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_EeA","cls2":"ExportFormatModal-cls2_sHG ExportFormatModal-cls1_EeA"};